// @flow
import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import Box from 'components/Box';
import { colors } from 'theme';
import type { Color } from 'theme';

const aFill = keyframes`
  from {
    transform: scaleX(0.001);
  }

  to {
    transform: scaleX(1);
  }
`;

const Amount = styled(Box)`
  transform: scaleX(0.001);
  transform-origin: left center;
  animation: ${aFill} ${props => props.$duration}s ${props => props.$delay}s
    forwards;
`;

export default ({
  total,
  current,
  color = 'marigold',
  duration = 1,
  delay = 0.33
}: {
  total: number,
  current: number,
  color?: Color,
  duration?: number,
  delay?: number
}) => (
  <Box overflow="hidden" borderRadius="3px" bg={colors.aluminum}>
    <Box width={`${(current / total) * 100}%`}>
      <Amount bg={color} height="6px" $delay={delay} $duration={duration} />
    </Box>
  </Box>
);
